import { createContext, useContext } from 'react'
import type { AuthSession } from '../lib/auth'

export const AuthContext = createContext<AuthSession>({
  authenticated: false,
  user: null,
  localUserId: null,
  organization: null,
  organizations: [],
  workspaces: [],
  activeWorkspace: null,
})

export function useAuth() {
  return useContext(AuthContext)
}
